import React from 'react';
import { motion } from 'framer-motion';
export function Navigation() {
  return <motion.header className="fixed top-0 left-0 right-0 z-40 py-4 px-6 bg-white/90 backdrop-blur-md border-b border-gray-100" initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-80">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-81">
        <a href="#" data-id="element-82">
          <img src="https://cdn.magicpatterns.com/uploads/iGVHPVKogVYsnUchuAbdfH/AVY_LOGO.svg" alt="AVY" className="h-10 w-10" data-id="element-83" />
        </a>

        <span className="text-xs text-gray-400 font-medium" data-id="element-84">AVY® | Confidential</span>
      </div>
    </motion.header>;
}